module.exports = __webpack_public_path__ + "img/office_online_edit.f27833bb.svg";